import { render, staticRenderFns } from "./MissingDocuments.vue?vue&type=template&id=e97db8ee"
import script from "./MissingDocuments.vue?vue&type=script&lang=js"
export * from "./MissingDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports